var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('VersionAlert',{staticClass:"mb-3"}),_vm._v(" "),_c('Funding')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }